(function() {
  'use strict';

  class MtAnimationSlideshow {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('[data-slideshow-slide]'));
      this.dots = Array.from(root.querySelectorAll('[data-slideshow-dot]'));
      this.prevBtn = root.querySelector('[data-slideshow-prev]');
      this.nextBtn = root.querySelector('[data-slideshow-next]');
      this.activeIndex = 0;
      this.destroyed = false;

      if (!this.slides.length) {
        this.destroyed = true;
        return;
      }

      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onDotClick = this.onDotClick.bind(this);

      this.init();
    }

    init() {
      this.updateSlides();
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', this.onPrev);
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', this.onNext);
      }
      this.dots.forEach((dot) => {
        dot.addEventListener('click', this.onDotClick);
      });
      
      // 添加触摸滑动支持（移动端和750-1024px分辨率）
      this.initTouchSwipe();
    }
    
    initTouchSwipe() {
      // 检查是否为移动端或750-1024px分辨率
      const isMobileOrTablet = () => {
        return window.innerWidth <= 1024;
      };
      
      if (!isMobileOrTablet()) {
        return; // 桌面端不启用触摸滑动
      }
      
      // 绑定到 viewport 容器，而不是单个 media 元素，确保切换后仍能响应
      const viewportElement = this.root.querySelector('.mt-animation-slideshow__viewport');
      if (!viewportElement) return;
      
      let touchStartX = 0;
      let touchEndX = 0;
      let touchStartY = 0;
      let touchEndY = 0;
      let isScrolling = false;
      let touchStarted = false;
      
      const handleTouchStart = (e) => {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
        isScrolling = false;
        touchStarted = true;
      };
      
      const handleTouchMove = (e) => {
        if (!touchStarted) return;
        
        if (!isScrolling) {
          const deltaX = Math.abs(e.changedTouches[0].screenX - touchStartX);
          const deltaY = Math.abs(e.changedTouches[0].screenY - touchStartY);
          // 如果垂直滑动距离大于横向滑动距离，认为是页面滚动
          if (deltaY > deltaX && deltaY > 10) {
            isScrolling = true;
          }
        }
      };
      
      const handleTouchEnd = (e) => {
        if (!touchStarted) return;
        
        // 先保存状态，然后立即重置
        const wasScrolling = isScrolling;
        touchStarted = false;
        isScrolling = false;
        
        if (wasScrolling) {
          return;
        }
        
        touchEndX = e.changedTouches[0].screenX;
        touchEndY = e.changedTouches[0].screenY;
        
        const diffX = touchStartX - touchEndX;
        const diffY = touchStartY - touchEndY;
        const minSwipeDistance = 50; // 最小滑动距离
        
        // 只有当横向滑动距离大于纵向滑动距离时才触发切换（避免与页面滚动冲突）
        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > minSwipeDistance) {
          // 使用 setTimeout 确保状态已重置，避免阻塞
          setTimeout(() => {
            if (diffX > 0) {
              // 向左滑动 - 下一张
              this.goTo(this.activeIndex + 1);
            } else {
              // 向右滑动 - 上一张
              this.goTo(this.activeIndex - 1);
            }
          }, 0);
        }
      };
      
      const handleTouchCancel = (e) => {
        // 触摸取消时重置所有状态
        touchStarted = false;
        isScrolling = false;
      };
      
      // 添加触摸事件监听器
      viewportElement.addEventListener('touchstart', handleTouchStart, { passive: true });
      viewportElement.addEventListener('touchmove', handleTouchMove, { passive: true });
      viewportElement.addEventListener('touchend', handleTouchEnd, { passive: true });
      viewportElement.addEventListener('touchcancel', handleTouchCancel, { passive: true });
      
      // 存储清理函数以便销毁时移除
      this._touchHandlers = {
        element: viewportElement,
        start: handleTouchStart,
        move: handleTouchMove,
        end: handleTouchEnd,
        cancel: handleTouchCancel
      };
    }

    onPrev(event) {
      event.preventDefault();
      this.goTo(this.activeIndex - 1);
    }

    onNext(event) {
      event.preventDefault();
      this.goTo(this.activeIndex + 1);
    }

    onDotClick(event) {
      event.preventDefault();
      const dot = event.currentTarget;
      const index = parseInt(dot.getAttribute('data-slideshow-dot'), 10);
      if (!Number.isNaN(index)) {
        this.goTo(index);
      }
    }

    goTo(index) {
      if (!this.slides.length) return;

      let target = index;
      if (target < 0) {
        target = this.slides.length - 1;
      } else if (target >= this.slides.length) {
        target = 0;
      }

      if (target === this.activeIndex) {
        return;
      }

      this.activeIndex = target;
      this.updateSlides();
    }

    updateSlides() {
      this.slides.forEach((slide, idx) => {
        const isActive = idx === this.activeIndex;
        slide.classList.toggle('is-active', isActive);
        controlSlideshowMedia(slide, isActive);
      });

      this.dots.forEach((dot, idx) => {
        const isActive = idx === this.activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    destroy() {
      if (this.destroyed) return;
      if (this.prevBtn) {
        this.prevBtn.removeEventListener('click', this.onPrev);
      }
      if (this.nextBtn) {
        this.nextBtn.removeEventListener('click', this.onNext);
      }
      this.dots.forEach((dot) => {
        dot.removeEventListener('click', this.onDotClick);
      });
      this.slides.forEach((slide) => {
        controlSlideshowMedia(slide, false);
      });
      
      // 清理触摸事件监听器
      if (this._touchHandlers) {
        const { element, start, move, end, cancel } = this._touchHandlers;
        element.removeEventListener('touchstart', start);
        element.removeEventListener('touchmove', move);
        element.removeEventListener('touchend', end);
        element.removeEventListener('touchcancel', cancel);
        this._touchHandlers = null;
      }
      
      this.destroyed = true;
    }
  }

  function controlSlideshowMedia(slide, shouldPlay) {
    if (!slide) return;
    const video = slide.querySelector('[data-slideshow-video]');
    if (!video) return;

    if (shouldPlay) {
      if (video.readyState >= 2) {
        video.play().catch(() => {});
      } else {
        const onCanPlay = () => {
          video.play().catch(() => {});
          video.removeEventListener('canplay', onCanPlay);
        };
        video.addEventListener('canplay', onCanPlay);
      }
    } else {
      video.pause();
      video.currentTime = 0;
    }
  }

  const instances = new Map();

  function initSlideshows(scope = document) {
    const roots = scope.querySelectorAll('[data-animation-slideshow]');
    roots.forEach((root) => {
      if (instances.has(root)) return;
      const instance = new MtAnimationSlideshow(root);
      if (!instance.destroyed) {
        instances.set(root, instance);
      }
    });
  }

  function destroySlideshows(scope = document) {
    const roots = scope.querySelectorAll('[data-animation-slideshow]');
    roots.forEach((root) => {
      const instance = instances.get(root);
      if (instance) {
        instance.destroy();
        instances.delete(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSlideshows());
  } else {
    initSlideshows();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSlideshows(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroySlideshows(event.target);
  });
})();

